<template>
  <div class="container mb-5">
    <b-card>
      <b-row align-h="center">
        <b-col :cols="12" :lg="9">
          <ol class="breadcrumb arr-right mb-0 mb-md-3 mt-4">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'bankHolidays' }" class="headings">{{
                $t('holidays.index.title')
              }}</router-link>
            </li>
            <li class="breadcrumb-item reference-heading">
              {{ $t('holidays.index.list') }}
            </li>
          </ol>
        </b-col>
      </b-row>
      <holiday-table
        v-if="!isMx"
        :title="holidays.IN.title"
        :subtext="holidays.IN.subtext"
        :fields="holidays.IN.fields"
        :holidayItems="holidays.IN.list"
      />
      <holiday-table
        v-if="isMx"
        :title="holidays.MX.title"
        :subtext="holidays.MX.subtext"
        :fields="holidays.MX.fields"
        :holidayItems="holidays.MX.list"
      />
      <b-row class="mt-4"></b-row>
      <holiday-table
        :title="holidays.US.title"
        :subtext="holidays.US.subtext"
        :fields="holidays.US.fields"
        :holidayItems="holidays.US.list"
      />
    </b-card>
  </div>
</template>

<script>
import HolidayTable from './HolidayTable.vue'

export default {
  data() {
    return {
      responseData: {},
      holidays: {
        IN: {},
        MX: {},
        US: {}
      }
    }
  },
  mounted() {
    this.getHolidayList(this.getLocale)
  },
  computed: {
    isMx() {
      return this.currentLocale === 'es-MX' || this.currentLocale === 'en-MX'
    },
    getLocale() {
      return this.currentLocale === 'es-MX' ? 'es-ES' : 'en-US'
    },
    currentLocale() {
      return this.$store.state.account.currentLocale
    }
  },
  watch: {
    '$store.state.account.currentLocale': {
      handler() {
        this.holidays = this.responseData[this.getLocale].holidays
      },
      deep: true
    }
  },
  methods: {
    async getHolidayList(locale) {
      const processEnv = process.env || {}
      const res = await fetch(
        `https://cdn.contentful.com/spaces/${processEnv.VUE_APP_CTF_SPACE_ID}/environments/${processEnv.VUE_APP_CTF_ENVIRONMENT}/entries?access_token=${processEnv.VUE_APP_CTF_TOKEN}&content_type=portalHolidayListing&locale=*`
      )
      const entries = await res.json()
      if (
        entries &&
        entries.items &&
        entries.items[0] &&
        entries.items[0].fields
      ) {
        this.responseData = entries.items[0].fields.data
        if (this.responseData[locale] && this.responseData[locale].holidays) {
          this.holidays = this.responseData[locale].holidays
        }
      }
    }
  },
  components: {
    HolidayTable
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.card-body {
  padding-bottom: 0 !important;
  font-family: $nunito;
}
.items-style {
  font-size: 14px;
  border-bottom: 1px solid $dc-form-border-color;
}
.fields {
  font-size: 16px;
}
.title-slash::after {
  left: 0;
}
.holiday-cell {
  color: $primary;
}
.heading-desc {
  font-size: 20px;
  font-weight: 600;
}
.heading-caption {
  font-size: 12px;
}
</style>
